import { render, staticRenderFns } from "./expressForward.vue?vue&type=template&id=103c6fd7&scoped=true"
import script from "./expressForward.vue?vue&type=script&lang=js"
export * from "./expressForward.vue?vue&type=script&lang=js"
import style0 from "./expressForward.vue?vue&type=style&index=0&id=103c6fd7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c6fd7",
  null
  
)

export default component.exports